export const DIALOG_TITLE = "Access the course";

export const DIALOG_CONTENT =
  "Are you sure you want to access the course?";

export const ACCESS_LINK_TEXT =
  "Access the lessons or jump to the lesson you want";

export const CHECKBOX_LABEL = "Show lesson reminder on dashboard";

export const SUCCESS_MESSAGE =
  "You have successfully enrolled in the course";

export const ERROR_ENROLL_MESSAGE = "Error enrolling";

export const SECTION_HEADING = "Workbook for Students";
